import React, {useState} from 'react'
import {connect} from 'react-redux'
import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../_metronic/helpers'
import {ProductsModal} from './ProductsModal'
import {AppState} from '../../setup/redux/Store'

interface Props {
  inspectorMode?: number
  inspectorId?: string
}

const ProductsButton: React.FC<Props> = ({inspectorMode, inspectorId}) => {
  const {t} = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <div className='menu-item'>
        <button
          className='menu-link without-sub w-100 text-start'
          onClick={handleOpenModal}
          style={{
            background: 'none',
            border: 'none',
            padding: '0.75rem 1rem',
            color: '#A1A5B7',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            cursor: 'pointer',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#009EF7'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#A1A5B7'
          }}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/ecommerce/ecm007.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>{t('SIDBAR_REDEEM_MASTERY')}</span>
        </button>
      </div>

      {isModalOpen && (
        <ProductsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          inspectorMode={inspectorMode}
          inspectorId={inspectorId}
        />
      )}
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  inspectorMode: state.auth.inspectorMode,
  inspectorId: state.auth.inspector_id,
})

const ConnectedProductsButton = connect(mapStateToProps)(ProductsButton)
export {ConnectedProductsButton as ProductsButton}
